import { PencilSimpleLine } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, IManagedNote } from 'core/components';
import { Variant } from 'theme/enums';

import { EditNote } from './EditNote';
import { inlineButtonStyle } from './style';

interface IProps {
  note: IManagedNote;
  onSubmit: (data: IManagedNote) => Promise<{ success: boolean }>;
  level?: number;
}

export const EditNoteButton = ({ note, onSubmit, level = 0 }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isEditable, isDeletable, tags, ...rest } = note;

  const { t } = useTranslation();

  const handleOnClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        text={t('buttonLabelEdit')}
        variant={Variant.PLAIN}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
        sx={inlineButtonStyle}
      />

      <EditNote
        isOpen={isOpen}
        onClose={handleOnClose}
        note={rest}
        onSubmit={onSubmit}
        level={level}
      />
    </>
  );
};
